/**
 * Central route path registry.
 * Every navigable path in the application is declared here — never
 * hardcode a path string inside a component.
 */
export const PATHS = {
  dashboard: "/",

  auth: {
    login: "/login",
    /** IRWMS single sign-on return leg (Keycloak redirect_uri). */
    ssoCallback: "/oidc/callback",
    forgotPassword: "/forgot-password",
    /** Emailed reset link (?token=…); with setup=1 it is a new account's "create password" link. */
    resetPassword: "/reset-password",
  },

  userManagement: {
    userAccess: "/user-management/user-access",
  },

  wheelData: {
    transactions: "/wheel-data/transactions",
    /** Parameterised single-wheelset detail route. */
    transaction: "/wheel-data/transactions/:id",
  },

  machineOps: {
    oxycut: "/machine-ops/oxycut",
    atl: "/machine-ops/atl",
    vtl: "/machine-ops/vtl",
    pressin: "/machine-ops/pressin",
    wheelLathe: "/machine-ops/wheel-lathe",
    bearingRtc: "/machine-ops/bearing-rtc",
    ctbrMaintenance: "/machine-ops/ctbr-maintenance",
  },

  inspection: {
    wheelsets: "/inspection/wheelsets",
    defective: "/inspection/defective-wheelsets",
    cmtCheck: "/inspection/cmt-check",
    airGauge: "/inspection/air-gauge",
  },

  maintenance: {
    /** Parameterised subcomponent maintenance route. */
    subcomponent: "/maintenance/:slug",
    wheelDisc: "/maintenance/wheel-disc",
    axle: "/maintenance/axle",
    ctrb: "/maintenance/ctrb",
    brakeDisc: "/maintenance/brake-disc",
    bearing: "/maintenance/bearing",
  },

  assemblyDispatch: {
    assembly: "/assembly-dispatch/assembly",
    adjustment: "/assembly-dispatch/adjustment",
    dispatch: "/assembly-dispatch/dispatch",
  },

  reports: "/reports",

  masters: {
    /** One screen carrying every catalogue as a tab; the tab is the sub-path. */
    root: "/masters",
    /** Two-column screen: zones on the left, the selected zone's divisions on the right. */
    zones: "/masters/zones",
    receiptSource: "/masters/receipt-source",
    wheelsetType: "/masters/wheelset-type",
    attention: "/masters/attention",
    detachmentReason: "/masters/detachment-reason",
    maintenanceType: "/masters/maintenance-type",
    inspection: "/masters/inspection",
  },
} as const;

/** Fills PATHS.wheelData.transaction — the only way to link to one wheelset. */
export function wheelsetDetailPath(transactionId: string): string {
  return `${PATHS.wheelData.transactions}/${encodeURIComponent(transactionId)}`;
}
